import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-liablity-support-doc',
    templateUrl: './liablity-support-doc.component.html',
    styleUrls: ['./liablity-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LiablitySupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
